<script>
  import { createEventDispatcher } from "svelte";
  import classNames from "../../utils/classNames";
  import CustomIcon from "../CustomIcon.svelte";
  import RenderTableLeftActions from "./RenderTableLeftActions.svelte";

  export let columns = [];
  export let sortBy = "";
  export let sortOrder = "";
  export let isChildTable = false;
  export let config;
  export let isAllSelected;

  let icon = "arrow_up_down";
  const sorts = ["ASC", "DESC"];
  const dispatch = createEventDispatcher();

  function handleSortChange(event, _sortBy) {
    const detail = {
      originalEvent: event,
      sortBy: _sortBy,
      sortOrder: "ASC",
    };

    if (sortBy === _sortBy) {
      detail.sortOrder = sorts.find((s) => s !== sortOrder) || "ASC";
    }
    dispatch("sortClick", detail);
  }

  function handleToggleSelectAll() {
    dispatch("selectAll", {});
  }

  $: {
    if (sortOrder === "ASC") icon = "arrow_asc";
    else icon = "arrow_desc";
  }
</script>

<thead>
  <tr>
    {#each columns as c, idx}
      <th
        class={classNames(
          "bg-custom-light-orange text-sm px-1.5",
          !isChildTable ? "py-4" : "py-4",
          config.stickyHeader && "top-0 sticky z-70",
          idx === 0 && config.stickyFirstColumn && "left-0 sticky z-90",
          idx + 1 === columns.length &&
            config.stickyLastColumn &&
            "right-0 sticky z-80",
          !config.multilineColumns && "whitespace-nowrap",
          idx !== 0 &&`min-w-[60px]`
        )}
      >
        {#if c.renderBy === "checkbox" || c.renderBy === "dropdown"}
          <RenderTableLeftActions
            renderBy={c.renderBy}
            isHeader={true}
            isChecked={isAllSelected}
            on:click={handleToggleSelectAll}
          />
        {:else}
          <div
            style:width={c.width ? `${c.width}px` : null}
            class={classNames(
              `flex flex-row items-center text-left justify-start gap-1 min-w-[${
                c.width ? c.width : 60
              }px]`,
              idx === 0 && "pl-6"
            )}
          >
            {c.label || ""}
            <!-- column sorting -->
            {#if c.sortBy}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                class="inline-block"
                role="button"
                on:click={(e) => handleSortChange(e, c.sortBy)}
              >
                <CustomIcon
                  name={sortBy === c.sortBy ? icon : "arrow_up_down"}
                  color={sortBy === c.sortBy ? "#F78907" : "#222"}
                  height={14}
                  width={14}
                />
              </div>
            {/if}
          </div>
        {/if}
      </th>
    {/each}
  </tr>
</thead>
